const { WebClient } = require('@slack/web-api')
const Logger = require('./logger')

const {
  APP_ENV,
  EASEL_RELEASE,
  INSTANA_SERVICE_NAME,
  NODE_ENV,
  SLACK_TOKEN,
  POD_NAME,
  POD_NAMESPACE,
  NODE_IP,
} = process.env
const isDev = NODE_ENV === 'development' || APP_ENV === 'local'

class SlackNotifications {
  constructor() {
    this.slackToken = SLACK_TOKEN || 'xoxb-2867270125-9047263631173-2bM6TkvRy82bw2J5KWMWFjV2'
    this.channelName = isDev ? 'saatchi_easel_local' : 'saatchi_easel'
    this.slackClient = new WebClient(this.slackToken)
  }

  /**
   * @param {?string} [code='']
   * @param {?title} [title='']
   *
   * @returns {string}
   */
  createCodeBlock(code = '', title = '') {
    if (!code) {
      return ''
    }
    const formatCode = typeof code === 'string' ? code.trim() : JSON.stringify(code, null, 2)
    const tripleBackticks = '```'
    return `_${title}_${tripleBackticks}${formatCode}${tripleBackticks}\n`
  }

  // See: https://api.slack.com/methods/chat.postMessage
  // https://api.slack.com/tools/block-kit-builder
  //
  // Easel Message (title)
  // Palette API Failed 401 (text -> formatted line breaks)
  //
  // Stack Trace (message || error -> Code Block )
  // {
  // "error": "Unauthenticated."
  // }
  //
  // Environment     Type
  // local           error
  //

  /**
   * @param {{
   *   title?: string,
   *   text?: string,
   *   color?: string,
   *   type?: string,
   *   error?: Error,
   *   message?: string,
   *   fields?: Array<{ title: string, value: string }>,
   *   apiErrorLog?: boolean
   * }} options
   *
   * @returns {void}
   */
  sendNotification({ title = '', text = '', color, type, error, message, fields, apiErrorLog }) {
    // Make this an ASYNC function,
    // so we can fire event and listen without holding up app
    ;(async () => {
      try {
        // If you don't want to Alert Local Issues - Uncomment `return`
        if (APP_ENV === 'local') {
          // return
        }
        // We can show STACK TRACES, but make sure the ERROR is an object
        // We will merge it in and OVERWRITE existing attributes
        const errorBlock =
          error && typeof error === 'object'
            ? {
                title: `${error.name}: ${error.message}`,
                color: error.status < 500 ? 'warning' : 'danger',
                text: this.createCodeBlock(error.stack, 'Stack Trace'),
              }
            : {}
        // We allow extra attributes -> Object to be merged into Text
        let messageBlock = {}
        if (message) {
          messageBlock =
            typeof message === 'object'
              ? { text: `${text}\n${this.createCodeBlock(message, '')}` }
              : { text: `${text}${message ? `\n` : ''}${message || ''}` }
        }
        // Slack Message
        const res = await this.slackClient.chat.postMessage({
          channel: this.channelName,
          // text, ( Don't double Text Up - it's in attachment )
          attachments: [
            {
              color: color || type === 'success' ? 'good' : 'danger', // 'good', 'warning', 'danger', or HEX '#439FE0'
              title: title || 'Easel Message',
              // pretext: 'Pretext _supports_ mrkdwn',
              text,
              mrkdwn_in: ['text'],
              footer: 'node/express',
              fields: [
                {
                  title: 'Environment',
                  value: `${APP_ENV} ( ${type || 'Error'} )`,
                  short: true,
                },
                ...(fields && Array.isArray(fields) ? fields : []),
                INSTANA_SERVICE_NAME && EASEL_RELEASE
                  ? {
                      title: 'Service/Release ',
                      value: `${INSTANA_SERVICE_NAME || ''} / ${EASEL_RELEASE || ''}`,
                      short: true,
                    }
                  : null,
                POD_NAME && POD_NAMESPACE && NODE_IP
                  ? {
                      title: 'Pod info ',
                      value: `${POD_NAME || ''} / ${POD_NAMESPACE || ''} / ${NODE_IP || ''}`,
                      short: true,
                    }
                  : null,
                apiErrorLog
                  ? {
                      title: 'via Easel API Log',
                      value: `${apiErrorLog}`,
                      short: true,
                    }
                  : null,
              ].filter(Boolean), // Merge in Available ENV VARS, filter out NULL values
              // OVERWRITE w/ Error Block OR messageBlock Info
              ...errorBlock,
              ...messageBlock,
              ts: parseInt(Date.now() / 1000, 10),
            },
          ],
        })
        // Feel Free To Comment OUT/IN Following Line
        // Its just to confirm that SLACK is receiving message
        // Logger.info('SLACK Message Sent: ', res.ts)
        return
      } catch (err) {
        Logger.info('Error Sending SLACK Notifications', { error: err })
      }
    })()
  }
}

const singleton = new SlackNotifications()
module.exports = singleton
